// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GenericClasses_wrapper__2Xjmt","loadingWrapper":"GenericClasses_loadingWrapper__G1DJp"};